import React from 'react';
import store from '../../store/Store';
import routes from '../../routes/Routes'

import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { Redirect } from 'react-router-dom';

import Navigation from '../navigation/Navigation'
import PageSelection from '../pageSelection/PageSelection'
import EditorContextMenu from '../editorContextMenu/EditorContextMenu'

import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Modal from '@material-ui/core/Modal';

import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Icon from "@material-ui/core/Icon";
import IconButton from '@material-ui/core/IconButton';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import VerticalSplitOutlinedIcon from '@material-ui/icons/VerticalSplitOutlined';
import HorizontalSplitOutlinedIcon from '@material-ui/icons/HorizontalSplitOutlined';
import HeightIcon from '@material-ui/icons/Height';
import CloseIcon from '@material-ui/icons/Close';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImageIcon from '@material-ui/icons/Image';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import NavigationOutlinedIcon from '@material-ui/icons/NavigationOutlined';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import EditIcon from '@material-ui/icons/Edit';
import BorderRightIcon from '@material-ui/icons/BorderRight';
import BorderLeftIcon from '@material-ui/icons/BorderLeft';
import BorderBottomIcon from '@material-ui/icons/BorderBottom';
import BorderTopIcon from '@material-ui/icons/BorderTop';
import BorderOuterIcon from '@material-ui/icons/BorderOuter';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import DashboardIcon from '@material-ui/icons/Dashboard';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import TableChartIcon from '@material-ui/icons/TableChart';
import DescriptionIcon from '@material-ui/icons/Description';
import QueueIcon from '@material-ui/icons/Queue';
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import SaveIcon from '@material-ui/icons/Save';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined';

import './editorInformation.scss';

type editorInformationState = {
	article: any;
  navigation: any;
  menu: any;
}

type editorInformationProps = {
	article: any;
	navigation: any;
}

class EditorInformation extends React.Component<editorInformationProps, editorInformationState> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
      	navigation: props.navigation,
        menu: store.getState().menu
  	}
  }

  componentDidMount() {
  	store.subscribe(() => {
  		this.setState({
  			article: store.getState().article,
        	navigation: store.getState().navigation,
          menu: store.getState().menu
  		})
  	})
  }

  componentWillUnmount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  details = () => {
    const { article } = this.state

    actions.articleActions.changeDetails({ details: !article.details })
  }

  login = () => {
  	console.log('Login')

  	store.dispatch({
  		type: actionTypes.REQUEST_LOGIN,
  		data: {
  			"success": true 
  		}
  	})

  	if (store.getState().login.loggedIn === true) {
  		console.log('LoggedIn')
  		store.dispatch({
  			type: actionTypes.CHANGE_ROUTE,
  			data: {
  				route: routes.ROUTE_ROOT
  			}
  		})
  	} else {
  		console.log('Not LoggedIn')
  	}
  }

  register = () => {
  	console.log('Register')

	store.dispatch({
		type: actionTypes.CHANGE_ROUTE,
		data: {
			route: '/register'
		}
	})

	store.dispatch({
		type: actionTypes.REQUEST_REGISTER,
		data: {
			register: true
		}
	})
  }

  splitVertical = () => {

  }

  splitHorizontal = () => {
  	
  }

  verticalSplit = () => {
    // console.log('Vertical Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    actions.articleActions.increaseColumns({
      index: article.info.currentPage
    })
  }

  horizontalSplit = () => {
    // console.log('Horizontal Split: ' + store.getState().template.templateIndex)

    const { article } = this.state

    actions.articleActions.increaseRows({
      index: article.info.currentPage
    })
  }

  onChangeDetailsOrientation = () => {
    const { article } = this.state

    actions.articleActions.changeDetailsOrientation({ detailsOrientation: article.detailsOrientation === 0 ? 1 : 0 })
  }

  onCloseDetails = () => {
    const { article } = this.state

    actions.articleActions.changeDetails({ details: !article.details })
  }

  onMouseOver = (id, clickEvent) => {
  	
  }

  onClicked = (id, clickEvent) => {
  	
  }

  onChangeWidth = (item, event) => {
    const { article, menu } = this.state

    console.log(menu.screenWidth)
    console.log(menu.screenHeight)
    console.log(menu.windowInnerWidth)
    console.log(menu.windowInnerHeight)

    if (event.target.value.includes('%')) {
      console.log('Valid % Entry')
    } else if (event.target.value.includes('px')) {
      console.log('Valid Pixel Entry')

      let columnWidth = parseInt(event.target.value.replace('px', ''))

      actions.articleActions.setWidth({
        index: article.info.currentPage,
        column: item.column,
        width: columnWidth
      })
    }
  }

  onChangeHeight = (item, event) => {
    const { article, menu } = this.state

    console.log(menu.screenWidth)
    console.log(menu.screenHeight)
    console.log(menu.windowInnerWidth)
    console.log(menu.windowInnerHeight)

    if (event.target.value.includes('%')) {
      console.log('Valid % Entry')
    } else if (event.target.value.includes('px')) {
      console.log('Valid Pixel Entry')

      let rowHeight = parseInt(event.target.value.replace('px', ''))

      actions.articleActions.setHeight({
        index: article.info.currentPage,
        row: item.row,
        height: rowHeight
      })
    }
  }

  checkFreeSpaceWidth = () => {
  
  }

  checkFreeSpaceHeight = () => {

  }

  renderSelectedDetails = () => {
    const { 
      article
    } = this.state

    let details = []
    let media = false
    let mediaType = -1
    let item
    let itemRow
    let itemColumn

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.selected.length === 1 && page.selected.map((pageItem, index, array) => {
        item = pageItem
        itemRow = pageItem.row
        itemColumn = pageItem.column
      })

      article.info.currentPage === page.index && page.media.map((item, index, array) => {
        item.row === itemRow && item.column === itemColumn ? media = true : null
        item.row === itemRow && item.column === itemColumn ? mediaType = item.type : null
      })
    })

    details.push(
      <div>
        Row: { itemRow }<br />
        Column: { itemColumn }<br />
        Widht:&nbsp;

        {
          <input 
            value={ item.width }
            autoFocus
            placeholder={ "e.g. 100px or 30%" }
            onChange={ this.onChangeWidth.bind(this, item) }
          />
        }

        <br />

        Height:&nbsp;

        {
          <input 
            value={ item.height }
            autoFocus
            placeholder={ "e.g. 100px or 30%" }
            onChange={ this.onChangeHeight.bind(this, item) }
          />
        }

        <br />

        Type:&nbsp;

        {
          mediaType === 0 ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Text
            </div>
          ) : mediaType === 1 ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Image
            </div>
          ) : mediaType === 2 ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Video
            </div>
          ) : (
            null
          )
        }

      </div>
    )

    return details
  }

  renderArticleDetails = () => {
    const { article } = this.state

    let articleDetails = []

    articleDetails.push(
      <div>
        Created: { article.info.creationTimestamp }<br />
        Updated: { article.info.updatedTimestamp }<br />
        Name: { article.info.name }<br />
        ID: { article.info.id }<br />
        Pages: { article.info.pages }<br />
        Current Page: { article.info.currentPage }<br />
        Previous Page: { article.info.previousPage }<br />
        Released: { article.info.released }<br />
        German: { article.info.languages.german }<br />
        English: { article.info.languages.english }
      </div>
    )

    return articleDetails
  }

  renderPageDetails = () => {
    const { article } = this.state

    let pageDetails = []
    let pageRows = 0
    let pageColumns = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? pageRows = page.rows : null
      article.info.currentPage === page.index ? pageColumns = page.columns : null
    })

    pageDetails.push(
      <div>
        Rows: { pageRows }<br />
        Columns: { pageColumns }<br />
        Spacing: <input onChange={ this.onChangeSpacing.bind(this) } placeholder={ article.spacing } /><br />
        Spacing Margin: <input type={ 'checkbox' } onChange={ this.onChangeSpacingMargin.bind(this) } checked={ article.spacingMargin } />
      </div>
    )

    return pageDetails
  }

  onChangeSpacing = (event) => {
  	console.log(event)
  	console.log(event.target)
  	console.log(event.target.value)

    const { article } = this.state

  	actions.articleActions.changeSpacing({
      index: article.info.currentPage,
		  spacing: parseInt(event.target.value)
  	})
  }

  onChangeSpacingMargin = (event) => {
  	console.log(event)
  	console.log(event.target)
  	console.log(event.target.value)

  	const { article } = this.state

    let spacingMargin

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? spacingMargin = !page.spacingMargin : null
    })

  	actions.articleActions.changeSpacingMargin({
      index: article.info.currentPage,
		  spacingMargin: spacingMargin
  	})
  }

  renderHoveredDetails = () => {
    const { article } = this.state

    let details = []
    let image = false
    let video = false
    let text = false

    for (let i = 0; i < article.image.length; i++) {
      if (article.hovered[0].row === article.image[i].row && article.hovered[0].column === article.image[i].column) {
        image = true
      }
    }

    for (let i = 0; i < article.video.length; i++) {
      if (article.hovered[0].row === article.video[i].row && article.hovered[0].column === article.video[i].column) {
        video = true
      }
    }

    for (let i = 0; i < article.text.length; i++) {
      if (article.hovered[0].row === article.text[i].row && article.hovered[0].column === article.text[i].column) {
        text = true
      }
    }

    details.push(
      <div>
        Row: { article.hovered[0].row }<br />
        Column: { article.hovered[0].column }<br />
        Widht:&nbsp;

        {
          article.width.map((item, index, array) => {
            console.log('Array: ' + array)
            console.log(array)
            console.log('Item: ' + item)
            console.log(item)
            console.log('Index: ' + index)
            console.log(index)

            if (item.column === article.hovered[0].column) {
              return item.width
            }
          })
        }

        <br />

        Height:&nbsp;

        {
          article.height.map((item, index, array) => {
            if (item.row === article.hovered[0].row) {
              return item.height
            }
          })
        }

        <br />

        Type:&nbsp;

        {
          text ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Text
            </div>
          ) : image ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Image
            </div>
          ) : video ? (
            <div
              style={{
                display: 'inline-block'
              }}
            >
              Video
            </div>
          ) : (
            null
          )
        }

      </div>
    )

    return details
  }

  checkMergeable = () => {
    console.log('Check Mergeable')

    return true
  }

  onMerge = () => {
    const {
      article
    } = this.state

    article.selected.sort((a, b) => a.row <= b.row && a.column <= b.column ? -1 : 1)

    let valid = false
    let singleRow = false
    let singleColumn = false

    let startRow = -1
    let startColumn = -1
    let endRow = -1
    let endColumn = -1

    let colSpanCount = -1
    let rowSpanCount = -1

    let skipStartRow = -1
    let skipRow = -1

    if (article.selected.length > 1) {
      for (let i = 0; i < article.selected.length; i++) {
        // console.log('[' + article.selected[i].row + ', ' + article.selected[i].column + ']')

        if (i === 0) {
          // console.log('First Selected')

          startRow = article.selected[i].row
          startColumn = article.selected[i].column
        } else if (i === article.selected.length - 1) {
          // console.log('Last Selected')

          endRow = article.selected[i].row
          endColumn = article.selected[i].column
        } else {
          // console.log('Middle Selected')
        }
      }
    }    

    let row = startRow
    let column = startColumn

    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    console.log('Start Row: ' + startRow)
    console.log('Start Column: ' + startColumn)
    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    colSpanCount = endColumn - startColumn + 1
    rowSpanCount = endRow - startRow + 1

    console.log('Column Span: ' + (endColumn - startColumn + 1))
    console.log('Row Span: ' + (endRow - startRow + 1))

    console.log('Skip Start Row: ' + (endColumn - startColumn))
    console.log('Skip Row: ' + (endColumn - startColumn + 1))

    skipStartRow = endColumn - startColumn
    skipRow = endColumn - startColumn + 1

    if (startRow === endRow) {
      singleRow = true
    }

    if (startColumn === endColumn) {
      singleColumn = true
    }

    actions.articleActions.addSpan({
      row,
      column,
      colSpanCount,
      rowSpanCount
    })

    for (let i = 0; i < rowSpanCount; i++) {
      if (i === 0) {
        actions.articleActions.addSkip({
          row,
          skip: skipStartRow
        })
      } else {
        actions.articleActions.addSkip({
          row: row + i,
          skip: skipRow
        })
      }
    }

    this.unselectAll()
  }

  closeModal = () => {
    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  resize = (value, key) => {
    const { navigation } = this.state

    let opposite = value === 0 ? 1 : 0

    console.log('RESIZE METHOD')

    navigation.resize.active && !key && navigation.resize.value === value ? (
      actions.navigationActions.resize({
        active: false,
        value: -1
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 0 ? (
      actions.navigationActions.resize({
        active: true,
        value: 2
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 1 ? (
      actions.navigationActions.resize({
        active: true,
        value: 2
      })
    ) : navigation.resize.active && !key && navigation.resize.value === 2 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : navigation.resize.active && key && navigation.resize.value === 0 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : navigation.resize.active && key && navigation.resize.value === 1 ? (
      actions.navigationActions.resize({
        active: true,
        value: opposite
      })
    ) : (
      actions.navigationActions.resize({
        active: true,
        value
      })
    )
  }

  preview = (preview) => {
    this.unselectAll()
    
    actions.articleActions.changePreview({
      preview
    })

    actions.routeActions.changeRoute({
      route: routes.ROUTE_ROOT
    })
  }

  saveTemplate = () => {
    console.log('Save Template')

    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  newTemplate = () => {
    console.log('New Template')

    actions.articleActions.newTemplate()
  }

  onAlign = (orientation) => {
    const { article } = this.state

    switch (orientation) {
      case 0:
        if (article.contextMenu.orientation === orientation) {
          actions.articleActions.changeContextMenu({
            subMenuOpen: false,
            fixed: false,
            orientation: -1,
            align: false
          })
        } else {
          actions.articleActions.changeContextMenu({
            fixed: true,
            orientation
          })
        }
        break
      case 1:
        if (article.contextMenu.orientation === orientation) {
          actions.articleActions.changeContextMenu({
            subMenuOpen: false,
            fixed: false,
            orientation: -1,
            align: false
          })
        } else {
          actions.articleActions.changeContextMenu({
            fixed: true,
            orientation
          })
        }
        break
      default:
        break
    }
  }

  renderAlignContextMenu = () => {
    const { article } = this.state

    let alignContextMenu = []

    alignContextMenu.push(
      <IconButton
        edge={ 'end' }
        className={ 'MenuButton' }
        color="inherit" 
        aria-label="menu"
        onClick={() => {
          actions.articleActions.changeContextMenu({
            subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.align ? true : false,
            resize: false,
            media: false,
            split: false,
            border: false,
            edit: false,
            article: false,
            align: !article.contextMenu.align
          })
        }}
      >
        <Icon
          style={{
            color: (article.contextMenu.orientation === 0 || article.contextMenu.orientation === 1) ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
          }}
        >
          <VerticalAlignCenterIcon />
        </Icon>
      </IconButton>
    )

    return alignContextMenu
  }

  onAddPage = () => {
    const { article } = this.state

    actions.articleActions.addPage(article.info.currentPage)
  }

  renderEdit = () => {
    const { article } = this.state

    let edit = []

    if (article.media.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        for (let j = 0; j < article.media.length; j++) {
          if (article.selected[i].row === article.media[j].row && article.selected[i].column === article.media[j].column) {
            if (article.media[j].type !== -1) {
              edit.push(
                <div
                  style={{
                    display: 'inline-block'
                  }}
                >
                  <IconButton
                    edge={ 'end' }
                    className={ 'MenuButton' }
                    color="inherit" 
                    aria-label="menu"
                    onClick={() => {
                      actions.articleActions.changeContextMenu({
                        subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.edit ? true : false,
                        resize: false,
                        media: false,
                        split: false,
                        border: false,
                        edit: !article.contextMenu.edit,
                        article: false,
                        align: false
                      })
                    }}
                  >
                    <Icon>
                      <EditIcon />
                    </Icon>
                  </IconButton>
                </div>
              )

              return edit
            }
          }
        } 
      }
    }
    
    return null
  }

  edit = () => {
    console.log('EDIT')
  }

  border = (all, direction) => {
    const { article } = this.state

    let included = false
    let borderIndex = -1

    if (article.selected.length > 0) {
      for (let selectedIndex = 0; selectedIndex < article.selected.length; selectedIndex++) {
        if (article.border.length < 1) {
          this.addBorder(article, selectedIndex, all, direction, borderIndex)
        } else if (article.border.length > 0) {
          for (let index = 0; index < article.border.length; index++) {
            if (article.selected[selectedIndex].row == article.border[index].row && article.selected[selectedIndex].column == article.border[index].column) {

              console.log('ALL: ' + all)
              console.log('DIRECTION: ' + direction)
              console.log('INDEX: ' + index)
              console.log('BORDERINDEX: ' + borderIndex)

              if (all && article.border[index].all) {
                included = true
              } else {
                borderIndex = index
                console.log('BORDERINDEX: ' + borderIndex)

                switch (direction) {
                  case 0:
                    article.border[index].top ? included = true : included = true
                    break
                  case 1:
                    article.border[index].right ? included = true : included = true
                    break
                  case 2:
                    article.border[index].bottom ? included = true : included = true
                    break
                  case 3:
                    article.border[index].left ? included = true : included = true
                    break
                  default:
                    break
                }
              }
            }
          }

          if (!included) {
            this.addBorder(article, selectedIndex, all, direction, borderIndex)
          } else {
            this.removeBorder(article, selectedIndex, all, direction, borderIndex)
          }
        }
      }
    }

    // this.unselectAll()
  }

  addBorder = (article, selectedIndex, all, direction, borderIndex) => {
    console.log('ADD BORDER: ' + all + ' ' + direction + ' ' + borderIndex)

    actions.articleActions.addBorder({
      row: article.selected[selectedIndex].row,
      column: article.selected[selectedIndex].column,
      all: all ? true : false,
      top: direction === 0 ? true : false,
      right: direction === 1 ? true : false,
      bottom: direction === 2 ? true : false,
      left: direction === 3 ? true : false
    })
  }

  removeBorder = (article, selectedIndex, all, direction, borderIndex) => {
    console.log('ADD BORDER: ' + all + ' ' + direction + ' ' + borderIndex)

    actions.articleActions.removeBorder({
      row: article.selected[selectedIndex].row,
      column: article.selected[selectedIndex].column,
      all: all ? true : false,
      top: direction === 0 ? true : false,
      right: direction === 1 ? true : false,
      bottom: direction === 2 ? true : false,
      left: direction === 3 ? true : false
    })
  }

  renderDetails = () => {
    const { navigation } = this.state

    let details = []

    details.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.details()
          }}
        >
          <Icon
            style={{
              color: navigation.details ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <MenuOpenIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return details
  }

  renderUnselect = () => {
    let unselect = []

    unselect.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.unselectAll()
          }}
        >
          <Icon>
            <SelectAllIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return unselect
  }

  renderPageSelection = () => {
    const { navigation } = this.state

    let pageSelection = []

    pageSelection.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.pageSelection()
          }}
        >
          <Icon
            style={{
              color: navigation.pageSelection ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <MoreVertIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return pageSelection
  }

  pageSelection = () => {
    // console.log('Render Navigation')

    let activePageSelection
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activePageSelection = !page.activePageSelection : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTablePageSelection({ 
      index: pageIndex,
      activePageSelection: activePageSelection
    })
  }

  renderNavigation = () => {
    const { navigation } = this.state

    let navi = []

    navi.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            this.navigation()
          }}
        >
          <Icon
            style={{
              color: navigation.navigation ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <NavigationOutlinedIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return navi
  }

  navigation = () => {
    // console.log('Render Navigation')

    let activeNavigation
    let pageIndex

    store.getState().article.pages.map((page, index, array) => {
      store.getState().article.info.currentPage === page.index ? activeNavigation = !page.activeNavigation : null
      store.getState().article.info.currentPage === page.index ? pageIndex = page.index : null
    })

    actions.articleActions.changeTableNavigation({ 
      index: pageIndex,
      activeNavigation: activeNavigation
    })
  }

  renderSplit = () => {
    const { article } = this.state

    let split = []

    split.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.split ? true : false,
              resize: false,
              media: false,
              split: !article.contextMenu.split,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon>
            <TableChartIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return split
  }

  renderResize = () => {
    const {
      navigation,
      article
    } = this.state

    let resize = []

    resize.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.resize ? true : false,
              resize: !article.contextMenu.resize,
              media: false,
              split: false,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon
            style={{
              color: navigation.resize.value === 0 || navigation.resize.value === 1 || navigation.resize.value === 2 ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <OpenWithIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return resize
  }

  renderMedia = () => {
    const { article } = this.state

    let media = []

    media.push(
      <div
        style={{
          display: 'inline-block'
        }}
      >
        <IconButton
          edge={ 'end' }
          className={ 'MenuButton' }
          color="inherit" 
          aria-label="menu"
          onClick={() => {
            actions.articleActions.changeContextMenu({
              subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.media ? true : false,
              media: !article.contextMenu.media,
              resize: false,
              split: false,
              border: false,
              edit: false,
              article: false,
              align: false
            })
          }}
        >
          <Icon
            style={{
              color: article.contextMenu.media ? 'rgba(155, 155, 155, 255)' : 'rgba(231, 231, 231, 255)'
            }}
          >
            <DashboardIcon />
          </Icon>
        </IconButton>
      </div>
    )

    return media
  }

  merge = () => {
    const {
      article
    } = this.state

    article.selected.sort((a, b) => a.row <= b.row && a.column <= b.column ? -1 : 1)

    let valid = false
    let singleRow = false
    let singleColumn = false

    let startRow = -1
    let startColumn = -1
    let endRow = -1
    let endColumn = -1

    let colSpanCount = -1
    let rowSpanCount = -1

    let skipStartRow = -1
    let skipRow = -1

    if (article.selected.length > 1) {
      for (let i = 0; i < article.selected.length; i++) {
        // console.log('[' + article.selected[i].row + ', ' + article.selected[i].column + ']')

        if (i === 0) {
          // console.log('First Selected')

          startRow = article.selected[i].row
          startColumn = article.selected[i].column
        } else if (i === article.selected.length - 1) {
          // console.log('Last Selected')

          endRow = article.selected[i].row
          endColumn = article.selected[i].column
        } else {
          // console.log('Middle Selected')
        }
      }
    }    

    let row = startRow
    let column = startColumn

    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    console.log('Start Row: ' + startRow)
    console.log('Start Column: ' + startColumn)
    console.log('End Row: ' + endRow)
    console.log('End Column: ' + endColumn)

    colSpanCount = endColumn - startColumn + 1
    rowSpanCount = endRow - startRow + 1

    console.log('Column Span: ' + (endColumn - startColumn + 1))
    console.log('Row Span: ' + (endRow - startRow + 1))

    console.log('Skip Start Row: ' + (endColumn - startColumn))
    console.log('Skip Row: ' + (endColumn - startColumn + 1))

    skipStartRow = endColumn - startColumn
    skipRow = endColumn - startColumn + 1

    if (startRow === endRow) {
      singleRow = true
    }

    if (startColumn === endColumn) {
      singleColumn = true
    }

    actions.articleActions.addSpan({
      row,
      column,
      colSpanCount,
      rowSpanCount
    })

    for (let i = 0; i < rowSpanCount; i++) {
      if (i === 0) {
        actions.articleActions.addSkip({
          row,
          skip: skipStartRow
        })
      } else {
        actions.articleActions.addSkip({
          row: row + i,
          skip: skipRow
        })
      }
    }

    this.unselectAll()
  }

  text = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.text.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 0,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 't'
          })
        } else if (article.text.length > 0) {
          for (let j = 0; j < article.text.length; j++) {
            if (article.selected[i].row == article.text[j].row && article.selected[i].column == article.text[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 0,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 't'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

  image = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.image.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 1,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'i'
          })
        } else if (article.image.length > 0) {
          for (let j = 0; j < article.image.length; j++) {
            if (article.selected[i].row == article.image[j].row && article.selected[i].column == article.image[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 1,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'i'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

  video = () => {
    const { article } = this.state

    let included = false

    if (article.selected.length > 0) {
      for (let i = 0; i < article.selected.length; i++) {
        if (article.video.length < 1) {
          actions.articleActions.addMedia({
            row: article.selected[i].row,
            column: article.selected[i].column,
            type: 2,
            id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'v'
          })
        } else if (article.video.length > 0) {
          for (let j = 0; j < article.video.length; j++) {
            if (article.selected[i].row == article.video[j].row && article.selected[i].column == article.video[j].column) {
              included = true
            }
          }

          if (!included) {
            actions.articleActions.addMedia({
              row: article.selected[i].row,
              column: article.selected[i].column,
              type: 2,
              id: 'p' + article.info.currentPage + 'r' + article.selected[i].row + 'c' + article.selected[i].column + 'v'
            })
          } else {
            actions.articleActions.removeMedia({
              row: article.selected[i].row,
              column: article.selected[i].column
            })
          }
        }
      }
    }

    // this.unselectAll()
  }

  unselectAll = () => {
    const { article } = this.state

    actions.articleActions.unselectSelectedCell({
      index: article.info.currentPage
    })
  }

  renderArticle = () => {
    const { article } = this.state

    let articleElement = []
    
    articleElement.push(
      <IconButton
        edge={ 'end' }
        className={ 'MenuButton' }
        color="inherit" 
        aria-label="menu"
        onClick={() => {
          actions.articleActions.changeContextMenu({
            subMenuOpen: !article.contextMenu.subMenuOpen ? true : article.contextMenu.subMenuOpen && !article.contextMenu.article ? true : false,
            resize: false,
            media: false,
            split: false,
            border: false,
            edit: false,
            article: !article.contextMenu.article,
            align: false
          })
        }}
      >
        <Icon>
          <DescriptionIcon />
        </Icon>
      </IconButton>
    )

    return articleElement
  }

  renderInformation = () => {
    const { article } = this.state

    let information = []
    let selectedLength = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? selectedLength = page.selected.length : null
    })

    information.push(
      <div
        style={{
          width: '100%'
        }}
      >
        
        {
          selectedLength === 0 ? this.renderInformationArticle() : null
        }

        {
          selectedLength === 0 ? this.renderInformationPage() : null
        }

        {
          selectedLength > 0 ? this.renderInformationCell() : null
        }

      </div>
    )
    
    return information
  }

  renderInformationArticle = () => {
    let article = []

    article.push(
      <div>
        <Typography 
          color="textSecondary" 
          gutterBottom
        >
          Article Information
        </Typography>

        <Typography 
          variant="body2" 
          component="p"
        >
                
          {
            this.renderArticleDetails()
          }

        </Typography>
      </div>
    )

    return article
  }

  renderInformationPage = () => {
    let page = []

    page.push(
      <div>
        <Typography 
          color="textSecondary" 
          gutterBottom
        >
          Page Information
        </Typography>

        <Typography 
          variant="body2" 
          component="p"
        >
                
          {
            this.renderPageDetails()
          }

        </Typography>
      </div>
    )

    return page
  }

  renderInformationCell = () => {
    const { article } = this.state

    let cell = []
    let selectedLength = 0

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index ? selectedLength = page.selected.length : null
    })

    cell.push(
      <div>
        <Typography 
          color="textSecondary" 
          gutterBottom
        >
          Cell Information
        </Typography>

        <Typography 
          variant="body2" 
          component="p"
        >
          
          {
            selectedLength === 1 ? (
              <div>
                Selected

                {
                  this.renderSelectedDetails()
                }

              </div>
            ) : selectedLength > 0 ? (
              <div>
                Selected: { selectedLength }
              </div>
            ) : (
              <div>
                
                {
                  this.renderPageDetails()
                }

              </div>
            )
          }

        </Typography>
      </div>
    )

    return cell
  }

  renderTable = () => {
  	const { article } = this.state
  	
  	let renderableTable = []

  	renderableTable.push(
	  	<table
  			style={{
        	width: article.activePageSelection ? 'calc(100vw - 50px)' : '100vw',
  				minWidth: article.activePageSelection ? 'calc(100vw - 50px)' : '100vw',
  				maxWidth: article.activePageSelection ? 'calc(100vw - 50px)' : '100vw',
  				height: article.activeNavigation ? 'calc(100vh - 50px)' : '100vh',
  				minHeight: article.activeNavigation ? 'calc(100vh - 50px)' : '100vh',
  				maxHeight: article.activeNavigation ? 'calc(100vh - 50px)' : '100vh',
  				borderCollapse: 'collapse',
          tableLayout: 'auto',
  				// borderTop: article.preview ? 'none' : article.activeNavigation ? '1px solid black' : 'none',
  				// borderLeft: article.preview ? 'none' : article.activePageSelection ? '1px solid black' : 'none'
  			}}
  			key={ 'templateTable' }
  		>
  			<tbody
          style={{
            width: 'inherit',
            minWidth: 'inherit',
            maxWidth: 'inherit',
            height: 'inherit',
            minHeight: 'inherit',
            maxHeight: 'inherit',
            borderCollapse: 'collapse'
          }}
        >

  				{
  					this.renderRows()
  				}

  			</tbody>			
  		</table>
  	)

    return renderableTable
  }

  renderRows = () => {
  	const { article } = this.state

  	let rows = []

  	for (let i = 0; i < article.rows; i++) {
  		rows.push(
  			<tr
  				style={{
  					overflow: 'hidden',
  					margin: 0,
  					padding: 0
  				}}
  				key={ i }
  			>

  				{
  					this.renderElement(i)
  				}

			 </tr>
		  )
    }

    return rows
  }

  renderElement = (row) => {
  	const { 
      article,
      navigation
    } = this.state

  	let data = []
  	let skip = 0
    let height = 0
    let width = 0

  	if (article.skip.length > 0) {
  		for (let h = 0; h < article.skip.length; h++)	{
  			if (article.skip[h].row === row) {
  				skip += article.skip[h].skip
  			}
  		}
  	}

  	for (let i = 0; i < (article.columns - skip); i++) {
  		let borderLeft = false
  		let borderRight = false
  		let borderTop = false
  		let borderBottom = false
  		let border = false
  		let selected = false
  		let hovered = false
  		let colSpan = 1
  		let rowSpan = 1
      let text = false
      let textId = ''
      let image = false
      let imageId = ''
      let video = false
      let videoId = ''

  		for (let j = 0; j < article.border.length; j++) {
  			if (article.border[j].row == row && article.border[j].column == i) {
  				if (article.border[j].all) {
  					console.log('Border All')
  					border = true
  				} else {
            if (article.border[j].top) {
              borderTop = true
            } 

            if (article.border[j].right) {
              borderRight = true
            }

            if (article.border[j].bottom) {
              borderBottom = true
            }

            if (article.border[j].left) {
              borderLeft = true
            }
          }
  			}	
  		}

  		for (let l = 0; l < article.hovered.length; l++) {
  			if (article.hovered[l].row == row && article.hovered[l].column == i) {
  				if (!article.preview) {
            hovered = true
          }
  			}	
  		}

      for (let l = 0; l < article.text.length; l++) {
        if (article.text[l].row == row && article.text[l].column == i) {
          text = true
          textId = 'p' + article.info.currentPage + 'r' + row + 'c' + i + 't'
        } 
      }

      for (let l = 0; l < article.image.length; l++) {
        if (article.image[l].row == row && article.image[l].column == i) {
          image = true
          imageId = 'p' + article.info.currentPage + 'r' + row + 'c' + i + 'i'
        } 
      }

      for (let l = 0; l < article.video.length; l++) {
        if (article.video[l].row == row && article.video[l].column == i) {
          video = true
          videoId = 'p' + article.info.currentPage + 'r' + row + 'c' + i + 'v'
        } 
      }

  		for (let l = 0; l < article.selected.length; l++) {
  			if (article.selected[l].row == row && article.selected[l].column == i) {
  				selected = true
  			}	
  		}

  		for (let m = 0; m < article.span.length; m++) {
  			if (article.span[m].row === row && article.span[m].column === i) {
  				colSpan = article.span[m].colSpanCount ? article.span[m].colSpanCount : 0
  			}
  		}

  		for (let n = 0; n < article.span.length; n++) {
  			if (article.span[n].row === row && article.span[n].column === i) {
  				rowSpan = article.span[n].rowSpanCount ? article.span[n].rowSpanCount : 0
  			}
  		}

  		let name = 'row' + row + 'column' + i
      
      let checkboard = false
      
      // console.log('Row: ' + row + ' Column: ' + i)
      // console.log('Row: ' + (row % 2 == 0))
      // console.log('Column: ' + (i % 2 == 0))

      row % 2 == 0 && i % 2 == 0 ? checkboard = true : row % 2 == 1 && i % 2 == 1 ? checkboard = true : null

      for (let j = 0; j < article.height.length; j++) {
        // console.log('Height')
        if (article.height[j].row === i) {
          height = article.height[j].height
          // console.log('Height: ' + height)
        }
      }

      for (let j = 0; j < article.width.length; j++) {
        // console.log('Width')
        if (article.width[j].row === i) {
          width = article.width[j].width
          // console.log('Width: ' + width)
        }
      }

  		data.push(
  			<td
  				style={{
   					resize: selected && navigation.resize.value === 0 ? 'vertical' : selected && navigation.resize.value === 1 ? 'horizontal' : selected && navigation.resize.value === 2 ? 'both' : 'none',
  					overflow: 'hidden',
  					margin: 0,
   					padding: 0,
            // width,
            // height,
   					borderLeft: border ? '1px solid black' : borderLeft ? '1px solid black' : 'none',
  					borderRight: border ? '1px solid black' : borderRight ? '1px solid black' : 'none',
  					borderTop: border ? '1px solid black' : borderTop ? '1px solid black' : 'none',
  					borderBottom: border ? '1px solid black' : borderBottom ? '1px solid black' : 'none'
  				}}
  				colSpan={ colSpan }
  				rowSpan={ rowSpan }
				  key={ 'row' + row + 'column' + i }
		    >
				
          {
            article.preview ? (
              <div
                className="TableElement"
                style={{
                  width: '100%',
                  height: '100%',
                  minWidth: '100%',
                  minHeight: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: text ? 'rgba(255, 255, 255, 255)' : 'rgba(33, 33, 33, 255)',
                  backgroundColor: hovered ? 'rgba(135, 192, 205, 255)' : selected ? 'rgba(83, 162, 180, 255)' : text ? 'rgba(57, 8, 121, 255)' : image ? 'rgba(184, 223, 16, 255)' : video ? 'rgba(0, 189, 189, 255)' : 'rgba(255, 255, 255, 255)',
                  // backgroundImage: table.preview && image ? 'url(images/editor-background.jpg)' : 'none',
                  // backgroundPosition: table.preview && image ? 'left' : 'none',
                  // backgroundRepeat: table.preview && image ? 'no-repeat' : 'none',
                  // backgroundSize: table.preview && image ? 'contain' : 'none',
                  objectFit: 'fill'
                }}

                onClick={ !article.preview ? this.onClicked.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) : null }
                onMouseOver={ this.onMouseOver.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) }
                onMouseOut={ this.onMouseOver.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) }
                id={ 'p' + article.info.currentPage + 'r' + row + 'c' + i }
              >
                
                {
                  text ? (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        minWidth: '100%',
                        minHeight: '100%',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        inlineSize: '100%',
                        overflowWrap: 'break-word'
                      }}
                    >
                      
                      {
                        false ? (
                          <p
                            style={{
                              display: 'inline-block',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            What is Lorem Ipsum?
                          </p>
                        ) : (
                          null
                        )
                      }

                      {
                        false ? (
                          <textarea
                            style={{
                              width: '100%',
                              height: '100%',
                              textAlign: 'justify',
                              backgroundColor: 'rgba(255, 255, 255, 0)',
                              resize: 'none',
                              overflow: 'hidden'
                            }}
                          />
                        ) : null
                      }

                      <p
                        style={{
                          width: '100%',
                          maxWidth: '100%',
                          height: '100%',
                          maxHeight: '100%',
                          whiteSpace: 'pre-line',
                          margin: 0,
                          padding: 0,
                          textAlign: 'justify',
                          color: 'rgba(0, 0, 0, 255)',
                          backgroundColor: 'rgba(255, 255, 255, 0)',
                          resize: 'none',
                          overflow: 'hidden'
                        }}
                        contentEditable={ true }
                      >

                      </p>
                      
                    </div>
                  ) : image ? (
                    <div
                      style={{
                        minWidth: '100%',
                        minHeight: '100%'
                      }}
                      id={ imageId }
                      onDragEnter={
                        this.dragEnter.bind(this)
                      }
                      onDragLeave={
                        this.dragLeave.bind(this)
                      }
                      onDrop={
                        this.drop.bind(this)
                      }
                      onDragOver={
                        this.dragOver.bind(this)
                      }
                    >

                    </div>
                  ) : video ? (
                    <iframe
                      style={{
                        width: '100%',
                        height: '100%'
                      }}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      src={ "https://www.youtube.com/embed/r-tEQzU3fwY?autoplay=1" }
                    />
                  ) : (
                    null
                  )
                }

              </div>
            ) : (
              <div
                className="TableElement"
                style={{
                  width: '100%',
                  height: '100%',
                  minWidth: '100%',
                  minHeight: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: text ? 'rgba(255, 255, 255, 255)' : 'rgba(33, 33, 33, 255)',
                  backgroundColor: hovered ? 'rgba(135, 192, 205, 255)' : selected ? 'rgba(83, 162, 180, 255)' : text ? 'rgba(57, 8, 121, 255)' : image ? 'rgba(189, 223, 16, 255)' : video ? 'rgba(0, 189, 189, 255)' : checkboard ? 'rgba(244, 244, 244, 255)' : (colSpan > 1 || rowSpan > 1) ? 'rgba(233, 233, 233, 255)' : 'rgba(255, 255, 255, 255)',
                  backgroundImage: article.preview && image ? 'url(images/editor-background.jpg)' : 'none',
                  backgroundPosition: article.preview && image ? 'center' : 'none',
                  backgroundRepeat: article.preview && image ? 'no-repeat' : 'none',
                  backgroundSize: article.preview && image ? 'fixed' : 'none'
                }}

                onClick={ this.onClicked.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) }
                onMouseOver={ this.onMouseOver.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) }
                onMouseOut={ this.onMouseOver.bind(this, 'p' + article.info.currentPage + 'r' + row + 'c' + i) }
                id={ 'p' + article.info.currentPage + 'r' + row + 'c' + i }
              >

              </div>
            )            
          }

			</td>
  		)
  	}

  	return data
  }

  dragEnter = (event) => {
    console.log('DRAG ENTER')

    console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  dragLeave = (event) => {
    console.log('DRAG LEAVE')

    console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  dragOver = (event) => {
    console.log('DRAG OVER')

    console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  drop = (event) => {
    console.log('DROP')

    console.log(event)
    console.log(event.target)
    console.log(event.target.id)
    console.log(event.dataTransfer.files)

    let targetId = event.target.id

    event.preventDefault()
    event.stopPropagation()

    let reader = new FileReader()
    reader.readAsDataURL(event.dataTransfer.files[0])
    reader.onloadend = function() {
      let img = document.createElement('img')
      img.src = reader.result as string

      console.log(img)

      img.style.width = '100%'
      img.style.height = '100%'
      document.getElementById(targetId).appendChild(img)
    }
  }

  	renderInformationActions = () => {
  		const { article } = this.state

  		let informationActions = []
      let selectedLength = 0

      article.pages.map((page, index, array) => {
        article.info.currentPage === page.index ? selectedLength = page.selected.length : null
      })

  		informationActions.push(
	  		<div>

				{ 
					selectedLength >= 2 && this.checkMergeable() ? (
						<Button
							size="small"
							style={{
								width: '100%',
								minWidth: '100%'
							}}
							onClick={
								this.onMerge.bind(this)
							}
						>
							Merge
						</Button>
					) : (
						<div>
							<Button
								size="small"
								style={{
									display: 'block',
									width: '100%',
									minWidth: '100%'
								}}
								onClick={
									this.onCloseDetails.bind(this)
								}
							>
								Close
							</Button>

							<Button
								size="small"
								style={{
									display: 'block',
									width: '100%',
									minWidth: '100%'
								}}
								onClick={
									this.onChangeDetailsOrientation.bind(this)
								}
							>
								Change Orientation
							</Button>
						</div>
					)
				}

			</div>
		)

		return informationActions
  	}

	render() {
		const { 
			article,
      		navigation
		} = this.state

		return (
			<div
				className="EditorInformation"
			>

				{
					!article.preview && article.details ? (
						<Card 
							style={{
								position: 'fixed',
								bottom: '0',
								zIndex: 1,
								right: article.detailsOrientation === 0 ? '0' : null,
								left: article.detailsOrientation === 1 ? '0' : null
							}}
						>
							<CardContent>

								{
									this.renderInformation()
								}

							</CardContent>

							<CardActions>
								
								{
									this.renderInformationActions()
								}

							</CardActions>
						</Card>
					) : (
						null
					)
				}
				
			</div>
		);
	}
}

export default EditorInformation;